module.exports = __webpack_public_path__ + "img/Bingo_Info_Game9.74eba72a.png";